import { IconProp, SizeProp } from '@fortawesome/fontawesome-svg-core';
import { faTrash } from '@fortawesome/free-solid-svg-icons/faTrash';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Tooltip, TooltipProps } from '../utils/local-antd';
import { AtiraIcon } from './AtiraIcon';
import { Button } from './Button';

type DeleteButtonProps = {
  onDelete: VoidFunction;
  text?: string;
  icon?: IconProp;
  width?: string;
  iconSize?: SizeProp;
} & Partial<TooltipProps>;

export const DeleteButton: React.FC<DeleteButtonProps> = ({
  onDelete,
  text,
  icon,
  iconSize = '2x',
  width = '25',
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={text || t('common.delete')} {...props}>
      <Button backgroundColor="transparent" onClick={onDelete}>
        <AtiraIcon size={iconSize} color="iconPrimary" icon={icon || faTrash} />
      </Button>
    </Tooltip>
  );
};
